import { notify } from './notifications';

export const parseErrorList = (error) =>
  Array.isArray(error.message) ? error.message.join(', ') : error.message;

export const notifyErrorMessage = (error) => {
  const message = parseErrorList(error);

  notify(message, 'error');
  return message;
};
